export const DOMAIN_TESTNET = process.env.VUE_APP_DOMAIN_TESTNET
export const DOMAIN_MAINNET = process.env.VUE_APP_DOMAIN_MAINNET

export const DOMAIN_STATS_MAINNET = process.env.VUE_APP_DOMAIN_STATS_MAINNET
export const DOMAIN_STATS_TESTNET = process.env.VUE_APP_DOMAIN_STATS_TESTNET
